import { HStack, Stack, VStack } from "@chakra-ui/react"
import { Text } from "@/components"
import { useResources } from "@/hooks"
import { Resource } from "@/types"
import { ResourceGridItem, ResourceListItem } from "./components"

export const ResourcesComponent = () => {
  const { data: resources } = useResources()

  return (
    <VStack>
      <VStack pt={10} pb={10} bg="gray.100" w="100%">
        <Text fontSize="5xl" fontWeight="bold">
          Helpful Resources
        </Text>
        <Text fontSize="md" color="text.muted">
          A curated list of resources to help you navigate your ESO journey
        </Text>
      </VStack>
      <HStack pl={20} pr={20} pt={10} w="100%" gap={10}>
        {
          resources && resources.length > 2 && (
            resources.slice(0, 2).map((resource: Resource, index: number) => (
              <ResourceGridItem key={index} resource={resource} />
            ))
          )
        }
      </HStack>
      <Stack pl={20} pr={20} pt={10} pb={10} w="100%" gap={5}>
        {
          resources.slice(2).map((resource: Resource, index: number) => {
            return (
              <ResourceListItem key={index} resource={resource} />
            )
          })
        }
      </Stack>
    </VStack>
  )
}
